/* global self,window */
import { default as cssBlankPseudoInit } from './browser';

(function (global) {
	global.cssBlankPseudoInit = cssBlankPseudoInit;
}('object' === typeof window && window || 'object' === typeof self && self || {}));
